import {
  IconName,
  IconDefinition,
  IconLookup
} from "@fortawesome/fontawesome-svg-core";

export const faAED: IconDefinition & IconLookup = {
  prefix: "fas",
  iconName: "aed" as IconName,
  icon: [
    26,
    26,
    [],
    "none",
    "M18.8,2c-2.5,0-4.6,1.8-5.8,3c-1.2-1.2-3.3-3-5.8-3C3,2,0,5,0,9.4c0,4.8,3.7,7.9,7.3,10.9C9,21.6,13,25,13,25s4-3.4,5.7-4.8 c3.6-3,7.3-6.1,7.3-10.9C26,5,23,2,18.8,2z M11.3,21l1.8-7H9.6L12,7h3.8l-2.2,5h3.7L11.3,21z" // svg path data
  ]
};
